import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import { Button } from '@mui/material'

const LinkedEvent = ({ formValues, handleChange, eventOptions }) => {
  const eventLocked =
    !!formValues?.incident?.createdFromTreatmentLocation ||
    !!formValues?.incident?.cadIncident
  const optionsArray = eventOptions.reduce((accumulator, event) => {
    const count = eventOptions.filter((x) => x.title === event.title)
    if (count.length > 1) {
      event.renderedTitle = `${event.title} (${moment(event.startDate).format(
        'ddd Do',
      )})`
    } else {
      event.renderedTitle = event.title
    }
    accumulator.push(event)
    return accumulator
  }, [])

  return (
    <Grid item xs={12} md={6} lg={3}>
      <FormControl
        fullWidth
        disabled={
          eventLocked ||
          eventOptions.length === 0 ||
          formValues?.incident?.incidentType !== 'Event'
        }
      >
        <InputLabel id="event-label">Event</InputLabel>
        <Select
          value={
            (formValues?.incident?.linkedEvent?._id
              ? formValues.incident.linkedEvent._id
              : formValues?.incident?.linkedEvent) || ''
          }
          onChange={(e) => {
            handleChange({
              moduleName: 'incident',
              field: 'linkedEvent',
              value: e.target.value,
            })
            handleChange({
              moduleName: 'incident',
              field: 'incidentType',
              value:
                e.target.value === null ? 'Off Duty or Travelling' : 'Event',
            })
          }}
          label="Event"
          name="linkedEvent"
          labelId="event-label"
        >
          {formValues?.incident?.linkedEvent?._id && (
            <MenuItem value={formValues?.incident?.linkedEvent?._id}>
              {formValues?.incident?.linkedEvent?.title}
            </MenuItem>
          )}
          {optionsArray
            .filter((x) => formValues?.incident?.linkedEvent?._id !== x._id)
            .map((event) => (
              <MenuItem value={event._id} key={event._id}>
                {event.renderedTitle}
              </MenuItem>
            ))}
          {!eventLocked && (
            <MenuItem value={null}>
              <Button
                size="small"
                variant="contained"
                fullWidth
                color="error"
                onClick={() => {
                  handleChange({
                    moduleName: 'incident',
                    field: 'linkedEvent',
                    value: undefined,
                  })
                  handleChange({
                    moduleName: 'incident',
                    field: 'incidentType',
                    value: 'Off Duty or Travelling',
                  })
                  if (formValues?.incident?.injuryOccurredAtEvent)
                    handleChange({
                      moduleName: 'incident',
                      field: 'injuryOccurredAtEvent',
                      value: undefined,
                    })
                }}
              >
                Remove Link to Event
              </Button>
            </MenuItem>
          )}
        </Select>
        {eventLocked ? (
          <FormHelperText>
            Event is set by the linked CAD incident or treatment location.
          </FormHelperText>
        ) : formValues?.incident?.incidentType !== 'Event' ? (
          <FormHelperText>
            Change incident type to Event to link an event.
          </FormHelperText>
        ) : optionsArray.length === 0 && (
          <FormHelperText>No Active Events</FormHelperText>
        )}
      </FormControl>
    </Grid>
  )
}

export default LinkedEvent
